/** Where this page's agent is running. The cloud copy has one address. */

export const CLOUD_PLATFORM_HOST = "app.agntspace.com";

const FLY_APP_HOST = /^agnt-[0-9a-f]{20}\.fly\.dev$/;

export function isCloudPlatform(hostname: string = typeof window === "undefined" ? "" : window.location.hostname): boolean {
	return hostname === CLOUD_PLATFORM_HOST;
}

/** A per-account machine's own hostname. The product address is the cloud host. */
export function isFlyAppHost(hostname: string): boolean {
	return FLY_APP_HOST.test(hostname);
}

/** The page was opened on the computer where the agent can run. */
export function isLocalComputer(hostname: string = typeof window === "undefined" ? "" : window.location.hostname): boolean {
	return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]";
}

export type RunWhere = "cloud" | "computer";

export function runWhere(hostname: string): RunWhere {
	return hostname === CLOUD_PLATFORM_HOST ? "cloud" : "computer";
}
